import {ReactNode, useState} from "react";

import Header from "./Header";
import Footer from "./Footer";
import Admin from "./Sidebar/Admin";

const Layout = ({ children }: { children: ReactNode }) => {
  const [isSidebarToggled, setIsSidebarToggled] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarToggled(!isSidebarToggled);
  };

  return(
    <div id="page-top" className={isSidebarToggled ? "sidebar-toggled" : ""}>
      <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
      <div id="wrapper">
        <Admin isToggled={isSidebarToggled} toggleSidebar={toggleSidebar} />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header toggleSidebar={toggleSidebar} />

            <div className="container-fluid">
              {children}
            </div>
          </div>

          <Footer />
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>

    </div>
  );
};

export default Layout;